export default __webpack_public_path__ + "static/media/log-de-error.a650fcdd.png";